import React from "react";

const industryKeynotes = [
  {
    number: 10,
    year: 2024,
    title: "AI with Empathy",
    event: "Decode the Future, KosICT Technology Festival",
    location: "XK",
  },
  {
    number: 9,
    year: 2023,
    title: "Past, Present and Future of AI Voice Assistants",
    event: "AI in Marketing, Marketing Week",
    location: "GR",
  },
  {
    number: 8,
    year: 2019,
    title: "The AI-Driven Marketing Strategy",
    event: "Marketing Analytics Summit",
    location: "IT",
  },
  {
    number: 7,
    year: 2019,
    title: "The Infusion of Machine Learning in Marketing",
    event: "Medtech Commercial Leaders Forum",
    location: "BE",
  },
  {
    number: 6,
    year: 2019,
    title: "Machine Learning in Marketing",
    event: "How Innovation Drives Growth, MediaCom",
    location: "CH",
  },
  {
    number: 5,
    year: 2019,
    title: "The Rise of AI Marketing",
    event: "Online Marketing Trend Conference",
    location: "CH",
  },
  {
    number: 4,
    year: 2018,
    title: "The Agile Digital (Marketing) Department",
    event: "MarTech, Marketing Week",
    location: "GR",
  },
  {
    number: 3,
    year: 2017,
    title: "New Frontiers of Digital Marketing",
    event: "Young Generation - Phonak @ Eataly",
    location: "IT",
  },
  {
    number: 2,
    year: 2017,
    title: "Digital Transformation in the Medical Device Industry",
    event: "Medtech Commercial Leaders Forum",
    location: "CH",
  },
  {
    number: 1,
    year: 2016,
    title: "How Digital Is Transforming Marketing",
    event: "MarTech Europe Conference",
    location: "UK",
  },
];

const invitedTalks = [
  {
    number: 21,
    year: 2025,
    title: "EU Business School",
    location: "Geneva, Switzerland",
    host: "Prof. Liouka",
  },
  {
    number: 20,
    year: 2024,
    title: "Sasin School of Management",
    location: "Thailand",
    host: "Prof. Connelly",
  },
  {
    number: 19,
    year: 2024,
    title: "Thammasa Business School",
    location: "Thailand",
    host: "Prof. Charinsarn",
  },
  {
    number: 18,
    year: 2024,
    title: "Sunway Business School",
    location: "Malaysia",
    host: "Prof. Lim",
  },
  {
    number: 17,
    year: 2024,
    title: "USCI Graduate Business School",
    location: "Malaysia",
    host: "Prof. Aw",
  },
  {
    number: 16,
    year: 2023,
    title: "Catholic University of Milan",
    location: "Italy",
    host: "Prof. La Rocca",
  },
  {
    number: 15,
    year: 2022,
    title: "Northwestern University in Qatar",
    location: "Qatar",
    host: "Prof. Allagui",
  },
  {
    number: 14,
    year: 2022,
    title: "SDA Bocconi School of Management",
    location: "Italy",
    host: "Prof. Mandelli",
    note: "(MOOC Big Data and AI)",
  },
  {
    number: 13,
    year: 2022,
    title: "Marche Polytechnic University",
    location: "Italy",
    host: "Prof. Pascucci",
  },
  {
    number: 12,
    year: 2021,
    title: "Saïd Business School, University of Oxford",
    location: "UK",
    host: "Prof. Ozcan",
    note: "(MOOC Digital Disruption)",
  },
  {
    number: 11,
    year: 2021,
    title: "Jyväskylä School of Business and Economics",
    location: "Finland",
    host: "Prof. Niininen",
  },
  {
    number: 10,
    year: 2021,
    title: "Grenoble School of Management",
    location: "France",
    host: "Prof. Liouka",
  },
  {
    number: 9,
    year: 2021,
    title: "Catholic University of Milan",
    location: "Italy",
    host: "Prof. La Rocca",
  },
  {
    number: 8,
    year: 2020,
    title: "University of London X Riinvest",
    location: "Kosovo",
    host: "Prof. Shala",
  },
  {
    number: 7,
    year: 2020,
    title: "Bocconi University",
    location: "Italy",
    host: "Prof. Mandelli",
  },
  {
    number: 6,
    year: 2019,
    title: "Marche Polytechnic University",
    location: "Italy",
    host: "Prof. Perna",
  },
  {
    number: 5,
    year: 2019,
    title: "University of Lugano",
    location: "Switzerland",
    host: "Prof. Mandelli",
  },
  {
    number: 4,
    year: 2019,
    title: "Jyväskylä School of Business and Economics",
    location: "Finland",
    host: "Prof. Niininen",
  },
  {
    number: 3,
    year: 2019,
    title: "Grenoble School of Management",
    location: "France",
    host: "Prof. Liouka",
  },
  {
    number: 2,
    year: 2019,
    title: "University of St. Gallen",
    location: "Switzerland",
    host: "Prof. Bresciani",
  },
  {
    number: 1,
    year: 2018,
    title: "ESA Business School",
    location: "Lebanon",
    host: "Prof. Som",
  },
];

const consultingProjects = [
  {
    number: 10,
    year: 2025,
    title: "Swiss Contact (foundation)",
    description:
      "Coordination international workshop – Executive leadership training",
  },
  {
    number: 9,
    year: 2024,
    title: "BRCCH (foundation)",
    description:
      "Research centre for child health – Scientists training on personal branding",
  },
  {
    number: 8,
    year: 2023,
    title: "Interex (company)",
    description:
      "Grocery retailing – Executive training on AI in retailing trends",
  },
  {
    number: 7,
    year: 2019,
    title: "Crownhealth (startup)",
    description: "Healthy sports nutrition – Digital marketing strategy",
  },
  {
    number: 6,
    year: 2019,
    title: "Hearing Home (startup)",
    description: "Hearing aids retailing – Business strategy",
  },
  {
    number: 5,
    year: 2018,
    title: "Snowcookie (startup)",
    description: "Wearable ski technology – Marketing strategy",
  },
  {
    number: 4,
    year: 2018,
    title: "Chalhoub Group",
    description: "Luxury retailing – Executive training on digital strategy",
  },
  {
    number: 3,
    year: 2018,
    title: "Safilo Group",
    description: "Eyewear segment – Executive coaching on social media",
  },
  {
    number: 2,
    year: 2017,
    title: "Sonova Italy",
    description: "Medical devices – Digital audit and recruiting",
  },
  {
    number: 1,
    year: 2009,
    title: "CP Start-up Lugano (startup)",
    description: "Digital services – Growth strategy coach",
  },
];

const Engagement: React.FC = () => {
  return (
    <section className="section active">
      {/* Hero section with image */}
      <div className="hero">
        <h1>Engagement</h1>
        <img
          src="/images/Alessandro-Mari-Speaker-Event-Marketing-AI.jpeg"
          alt="Dr. Alex Mari - Engagement"
          className="hero-image"
        />
      </div>

      {/* Main content with consistent spacing */}
      <div className="bio">
        <h2>Awards</h2>

        <div className="publication-list">
          <div className="publication-item">
            <strong>1. Academia:</strong> (2022) Stanley C. Hollander for{" "}
            <strong>Best Retailing Paper</strong> by the Academy of Marketing
            Science
          </div>
          <div className="publication-item">
            <strong>2. Industry:</strong> (2016) Top 50{" "}
            <strong>Marketing Technology</strong> Influencers, Onalytica
          </div>
          <div className="publication-item">
            <strong>3. Corporate:</strong> (2012){" "}
            <strong>Leadership Award</strong> "Power of You" by P&G (Vice
            President)
          </div>
        </div>

        <h2>Academia</h2>

        <h3>Invited Research Talks (21)</h3>
        <div className="publication-list">
          {invitedTalks.map((talk) => (
            <div
              key={talk.number}
              className="publication-item"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <span style={{ minWidth: "40px", flexShrink: 0 }}>
                ({talk.number})
              </span>
              <span
                style={{
                  minWidth: "80px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  flexShrink: 0,
                }}
              >
                {talk.year}
              </span>
              <span style={{ flex: 1, paddingLeft: "0" }}>
                {talk.title}, {talk.location} – <strong>{talk.host}</strong>
                {talk.note && <span> {talk.note}</span>}
              </span>
            </div>
          ))}
        </div>

        <h3>Ad-hoc Peer Reviewer (14 Journals)</h3>
        <div className="publication-list">
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Journal of Business Research
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Management Decision
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Information Systems Journal
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Tourism and Hospitality Research
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              European Journal of Marketing
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              International Journal of Human-Computer Interaction
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>ACM CHI</span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Behaviour & Information Technology
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Journal of Industrial and Business Marketing
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Humanities and Social Sciences Communications
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Australian Journal of Psychology
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              AI and Ethics
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              AI & Society
            </span>
          </div>
          <div className="publication-item" style={{ display: "flex" }}>
            <span style={{ minWidth: "25px", fontSize: "16px", flexShrink: 0 }}>
              –
            </span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              npj Mental Health Research
            </span>
          </div>
        </div>

        <h2>Industry</h2>

        <h3>Industry Keynote Presentations (10)</h3>
        <div className="publication-list">
          {industryKeynotes.map((keynote) => (
            <div
              key={keynote.number}
              className="publication-item"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <span style={{ minWidth: "40px", flexShrink: 0 }}>
                ({keynote.number})
              </span>
              <span
                style={{
                  minWidth: "80px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  flexShrink: 0,
                }}
              >
                {keynote.year}
              </span>
              <span style={{ flex: 1, paddingLeft: "0" }}>
                {keynote.title}, <em>{keynote.event}</em> ({keynote.location})
              </span>
            </div>
          ))}
        </div>

        <h3>Consulting and Coaching Projects (10)</h3>
        <div className="publication-list">
          {consultingProjects.map((project) => (
            <div
              key={project.number}
              className="publication-item"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              <span style={{ minWidth: "40px", flexShrink: 0 }}>
                ({project.number})
              </span>
              <span
                style={{
                  minWidth: "80px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  flexShrink: 0,
                }}
              >
                {project.year}
              </span>
              <span style={{ flex: 1, paddingLeft: "0" }}>
                {project.title} – {project.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Engagement;
